// import { showInfoMsg, showErrorMsg } from '@/utils/popInfo'
import ElementUI from 'element-ui';
import address from '../request/url'
// 心跳定时器
let heartbeatTimer
//初始化连接
function initWebSocket(e) {
    const wsUri = address.webIp+ "webSocket/" + e;
    this.socket = new WebSocket(wsUri)//这里面的this都指向vue
    this.socket.onerror = webSocketOnError;
    this.socket.onmessage = webSocketOnMessage;
    this.socket.onclose = closeWebsocket;
    // 监听连接建立事件
    this.socket.onopen = () => {
        // 设置心跳定时器，定时发送心跳消息
        heartbeatTimer = setInterval(sendHeartbeat.bind(this), 30000); // 30秒发送一次心跳消息
    };

}
// 发送心跳消息
function sendHeartbeat() {
    if (this.socket.readyState === WebSocket.OPEN) {
        // 构造心跳消息，可以是一个特定的消息内容，如"ping"
        const heartbeatMsg = "ping";
        this.socket.send(heartbeatMsg);

    }
}
//连接异常触发
function webSocketOnError(e) {

}
//接收后端消息
function webSocketOnMessage(e) {
    const data = JSON.parse(e.data);
    if (data.status === "success") {
        ElementUI.Notification({
            title: '',
            message: data.msg,
            type: 'success',
            duration: 0
        });

    } else if (data.status === "error") {
        ElementUI.Notification({
            title: '',
            message: data.msg,
            type: 'error',
            duration: 0,
        });
    }
}
// 连接关闭websiocket
function closeWebsocket() {
    // 清除心跳定时器
    clearInterval(heartbeatTimer);
}
//主动关闭连接
function close() {
    // 清除心跳定时器
    clearInterval(heartbeatTimer);
    this.socket.close() // 关闭 websocket
    this.socket.onclose = function (e) {
    }
}
//发送消息给后端
function webSocketSend(agentData) {
    this.socket.send(agentData);
}

export default {
    initWebSocket, close
}